import script from "./BusinessDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./BusinessDetail.vue?vue&type=script&lang=ts&setup=true"

import "./BusinessDetail.vue?vue&type=style&index=0&id=4d931b46&scoped=true&lang=less"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d931b46"]])

export default __exports__